import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import styled from 'styled-components';
import muiThemeable from 'material-ui/styles/muiThemeable';
import FlatButton from 'material-ui/FlatButton';

import { logoutUser } from '../../actions/userActions';
import Navigation from './Navigation';

import { menuRoutes } from '../../routes'
const Outer = styled.div`
  background-color: ${props => props.bg};
`;
const Container = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  display: flex;
`

class Header extends Component {
  state = {
    menuLinks: [],
  }
  componentDidMount() {
    const filteredMenuLinks = menuRoutes.filter(link => {
      if (!link.roles) {
        return true
      }
      return link.roles.includes(this.props.userRole);
    })

    this.setState({
      menuLinks: filteredMenuLinks
    })
  }
  _handleLogout = (event) => {
    this.props.logoutUser()
  }
  render() {
    return (
      <Outer bg={this.props.muiTheme.palette.primary1Color}>
        <Container>
          <Navigation items={this.state.menuLinks}></Navigation>
          <div style={{flex: 1}}></div>
          <div style={{padding: '6px'}}>
            <FlatButton backgroundColor="white" hoverColor="#dfdfdf" onTouchTap={this._handleLogout}>Logout</FlatButton>
          </div>
        </Container>
      </Outer>
    );
  }
}

const mapStateToProps = state => ({ user: state.user.user, userRole: state.user.role });
const mapDispatchToProps = { logoutUser };
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(muiThemeable()(Header)));



// WEBPACK FOOTER //
// ./src/components/Header/Header.js